import {
  COUNTRY_CODE_FAILED,
  COUNTRY_CODE_REQUEST,
  COUNTRY_CODE_SUCCESS,
} from "../constant/LanguageConstants";
import axios from "../../config/axios";

export const getAllCountryList = () => async (dispatch) => {
  dispatch({
    type: COUNTRY_CODE_REQUEST,
  });

  await axios
    .get("/country-code-list")
    .then((res) => {
      if (res.data.status === 1) {
        dispatch({
          type: COUNTRY_CODE_SUCCESS,
          payload: res.data.data,
        });
      } else {
        dispatch({
          type: COUNTRY_CODE_FAILED,
          payload: res.data,
        });
      }
    })
    .catch((err) => {
      console.error(err);
      dispatch({
        type: COUNTRY_CODE_FAILED,
        payload: err?.response?.data,
      });
    });
};
